import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal';
import ReactLoading from 'react-loading';
import PrimaryTable from '../helpers/primary-table'
import { catchError } from '../helpers/catch-error'
import { FaBars, FaPen } from "react-icons/fa";




const Facilities = () => {
    const navigate = useNavigate();
    const [facilityEdit, setFacilityEdit] = useState({});
    const [facilityAdd, setFacilityAdd] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [addMode, setAddMode] = useState(false);

    const [facilitySearch, setFacilitySearch] = useState({});
    const [isBtn, setIsBtn] = useState(false)
    const [inputError, setInputError] = useState(false);
    const [facilities, setFacilities] = useState(null);
    const [facilitiesChecked, setFacilitiesChecked] = useState([]);
    const [isMergeModalOpen, setIsMergeModalOpen] = useState(false);
    const [facilityChecked, setFacilityChecked] = useState(null);

    const [searchMode, setSearchMode] = useState(false);
    const [editFacilityModalOpen, setEditFacilityModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    var columns = React.useMemo(
        () => [
            {
                accessorFn: row => <div style={{ width: "140px" }}>
                    <input className="me-2" type="checkbox" name="merge[]" value={row.facility_id} />
                    <button className="btn btn-sm  btn-success me-1" onClick={() => editFacility(row.facility_id)}  ><FaPen title="EDIT" /></button>
                    {localStorage.getItem('@admin_role') == 1 &&
                        <a className="btn btn-sm  btn-success me-1" href={"/admin/report-work-orders-facility/" + row.facility_id}  ><FaBars title="REPORTS" /></a>}
                </div>,
                id: "action",
                cell: info => info.getValue(),
                header: () => "ACTION",
                footer: props => props.column.id,
                enableColumnFilter: false,
                enableSorting: false,

            },
            {
                accessorKey: "facility_name",
                header: () => "Name",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_attn",
                header: "ATTN",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_time_zone",
                header: "TIMEZONE",
                footer: props => props.column.id
            },
            {
                accessorFn: row => row.facility_address + ", " + row.facility_city + ", " + row.facility_state + ", " + row.facility_zip,
                id: "address",
                cell: info => info.getValue(),
                header: () => "ADDRESS",
                footer: props => props.column.id
            },
            {
                accessorFn: row => row.facility_phone,
                id: "phone",
                cell: info => info.getValue(),
                header: () => "PHONE",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_fax",
                header: "FAX",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_contact_name",
                header: "CONTACT",
                footer: props => props.column.id
            }
        ],
        []
    )

    useEffect(() => {

        getFacilities();

    }, []);

    useEffect(() => {

        console.log(facilitiesChecked);

    }, [facilitiesChecked]);


    const getFacilities = async () => {
        setIsLoading(true);
        setFacilityEdit({});
        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facilities", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setFacilities(response?.data?.facilities);
                setIsLoading(false);

            } else {

                Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)


        });

    }




    const editFacility = async (facility_id) => {

        setFacilityEdit({});
        setIsLoading(true);
        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facility-by-id/" + facility_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {
            setIsLoading(false);
            if (response?.data?.status) {

                let d = response?.data?.facility;
                setEditFacilityModalOpen(true);
                setFacilityEdit(d);


            } else {

                Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

            }
        }).catch(function (error) {
            setIsLoading(false);
            catchError(error, navigate)
        });

    }



    const saveFacility = async (e) => {

        setIsBtn(true);

        const { facility_name, facility_address, facility_city, facility_state, facility_zip, facility_phone, facility_contact_name } = facilityAdd;
        if (!facility_name || !facility_address || !facility_city || !facility_state || !facility_zip || !facility_phone || !facility_contact_name) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var facility_info = {
                facility_name: facilityAdd?.facility_name,
                facility_attn: facilityAdd?.facility_attn,
                facility_address: facilityAdd?.facility_address,
                facility_city: facilityAdd?.facility_city,
                facility_state: facilityAdd?.facility_state,
                facility_zip: facilityAdd?.facility_zip,
                facility_contact_name: facilityAdd?.facility_contact_name,
                facility_contact_phone: facilityAdd?.facility_contact_phone,
                facility_contact_fax: facilityAdd?.facility_contact_fax,
                facility_contact_email: facilityAdd?.facility_contact_email,
                facility_phone: facilityAdd?.facility_phone,
                facility_fax: facilityAdd?.facility_fax,
                facility_fee: facilityAdd?.facility_attn,
                facility_time_zone: facilityAdd?.facility_time_zone,
                facility_notes: facilityAdd?.facility_notes,
                facility_internal_notes: facilityAdd?.facility_internal_notes,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-facility", facility_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setEditMode(false)
                    setAddMode(false)
                    getFacilities();

                    setIsBtn(false)
                    Swal.fire({ icon: "success", title: "Facility Add", text: "New facility has been added successfully." });

                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }


    const updateFacility = async (e) => {

        setIsBtn(true);

        const { facility_name, facility_address, facility_city, facility_state, facility_zip, facility_phone } = facilityEdit;
        if (!facility_name || !facility_address || !facility_city || !facility_state || !facility_zip || !facility_phone) {



            setInputError(true);
            setIsBtn(false);

        } else {

            var facility_info = {
                facility_id: facilityEdit?.facility_id,
                facility_name: facilityEdit?.facility_name,
                facility_attn: facilityEdit?.facility_attn,
                facility_address: facilityEdit?.facility_address,
                facility_city: facilityEdit?.facility_city,
                facility_state: facilityEdit?.facility_state,
                facility_zip: facilityEdit?.facility_zip,
                facility_contact_name: facilityEdit?.facility_contact_name,
                facility_contact_phone: facilityEdit?.facility_contact_phone,
                facility_contact_fax: facilityEdit?.facility_contact_fax,
                facility_contact_email: facilityEdit?.facility_contact_email,
                facility_phone: facilityEdit?.facility_phone,
                facility_fax: facilityEdit?.facility_fax,
                facility_time_zone: facilityEdit?.facility_time_zone,
                facility_notes: facilityEdit?.facility_notes,
                facility_internal_notes: facilityEdit?.facility_internal_notes,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-facility", facility_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setEditMode(false)
                    setAddMode(false)


                    setIsBtn(false)
                    setEditFacilityModalOpen(false);
                    Swal.fire({ icon: "success", title: "Facility Update", text: "Facility has been updated successfully." });
                    getFacilities();


                } else {
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }


    }



    const searchFacilities = () => {

        setIsBtn(true);

        var search_elements = {}
        search_elements.facility_name = facilitySearch?.facility_name;
        search_elements.facility_contact_name = facilitySearch?.facility_contact_name;
        search_elements.facility_address = facilitySearch?.facility_address;
        search_elements.facility_city = facilitySearch?.facility_city;
        search_elements.facility_state = facilitySearch?.facility_state;
        search_elements.limit = 200;


        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-facilities", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {


            if (response?.data?.status) {

                setFacilities(response?.data?.facilities);

            }
            else {
                setFacilities(null);

            }
            setIsBtn(false);
        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });


    }


    const resetSearchFacilities = () => {

        setSearchMode(false);
        setFacilitySearch(null);
        getFacilities();
    }



    const resetAddFacility = () => {


        setAddMode(false);
        setFacilityAdd({});
    }


    const mergeFacilities = () => {


        var array = []
        var checkboxes = document.querySelectorAll('input[name="merge[]"]:checked')

        for (var i = 0; i < checkboxes.length; i++) {
            array.push(checkboxes[i].value)
        }

        let filteredFacilities = facilities.filter((f) => {

            return array.includes(f.facility_id.toString());
        });
        setFacilitiesChecked(filteredFacilities);
        console.log(filteredFacilities);

        setIsMergeModalOpen(true);

    }



    const saveMergeFacilities = () => {

        if(!facilityChecked?.facility_id){
      
            Swal.fire({ icon: "error", title: "Please select primary facility. " });
      return 0;

  }
        if(facilitiesChecked?.length < 2 || facilitiesChecked?.length > 5){
      
                  Swal.fire({ icon: "error", title: "You cannot merge more than 5 facilities at a time. " });
            return 0;

        }

        Swal.fire({
            title: "Are you sure, you want to merge this?",
            text: "You won't be able to revert this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, merge them!"
        }).then((result) => {
            if (result.isConfirmed) {

                axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/merge-facilities",
                    { facility_id: facilityChecked.facility_id,
                      facility_ids : facilitiesChecked?.map(a => a.facility_id) 
                     },
                    {
                        withCredentials: true
                    })
                    .then(function (response) {

                        if (response?.data?.status) {

                            setIsMergeModalOpen(false);

                            Swal.fire({ icon: "success", title: "Merged successfully." });

                            getFacilities();
                        } else {

                            Swal.fire({ icon: "error", title: "Unable to merge facilities", text: response?.data?.message });

                        }

                    })
                    .catch(function (error) {
                      
                        catchError(error,navigate)
                    });

            }
        });
       

    }

    return (
        <>



            <div className="row pb-2 mt-4">
                <div className="col-md-4 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">FACILITIES</h3>
                </div>

                <div className="col-md-8 col-sm-12 text-md-end -2">
                    {!searchMode && !addMode &&
                        <>
                            <button onClick={() => { setSearchMode(true); setFacilitySearch({}) }} className="btn btn-success me-1">SEARCH</button>
                            <button onClick={() => { setAddMode(true); setFacilityAdd({}); }} className="btn btn-warning  me-1">ADD NEW</button>
                            <button onClick={() => { mergeFacilities() }} className="btn btn-danger">MERGE</button>
                        </>
                    }
                </div>
            </div>

            {(addMode) &&

                <div className="card card-form card-primary mb-3">
                    <div className="card-heading px-5 py-2"><h6 className="fw-bold my-0">ADD NEW FACILITY</h6></div>
                    <div className="card-body">
                        <div className="row px-3 py-2 gx-2 form-thick">

                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <label htmlFor="facility_name" >Facility*</label>

                                <input name="facility_name" className="form-control" type="text"
                                    value={facilityAdd?.facility_name}
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_name: e.target.value })
                                    }

                                />
                                {inputError && !facilityAdd?.facility_name &&
                                    <span className="text-danger">Enter valid name</span>
                                }




                            </div>
                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <label htmlFor="facility_attn">ATTN</label>

                                <input name="facility_attn" className="form-control"
                                    value={facilityAdd?.facility_attn}
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_attn: e.target.value })
                                    }

                                />
                                {inputError &&
                                    !facilityAdd?.facility_attn && (
                                        <span className="text-danger">Enter valid attn</span>
                                    )}


                            </div>


                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <label htmlFor="facility_time_zone">Time Zone</label>

                                <select name="facility_time_zone" className=" form-select"
                                    value={facilityAdd?.facility_time_zone}
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_time_zone: e.target.value })
                                    }
                                >
                                    <option value="" selected={(!facilityAdd?.facility_time_zone || facilityAdd?.facility_time_zone == "") ? "selected" : ""} ></option>
                                    <option value="OUS" selected={(facilityAdd?.facility_time_zone == "OUS") ? "selected" : ""} >OUS - Outside The United States</option>
                                    <option value="EST" selected={(facilityAdd?.facility_time_zone == "EST") ? "selected" : ""}>EST: Eastern Standard Time</option>
                                    <option value="CST" selected={(facilityAdd?.facility_time_zone == "CST") ? "selected" : ""}>CST: Central Standard Time</option>
                                    <option value="MST" selected={(facilityAdd?.facility_time_zone == "MST") ? "selected" : ""}>MST - Mountain Standard Time</option>
                                    <option value="PST" selected={(facilityAdd?.facility_time_zone == "PST") ? "selected" : ""}>PST - Pacific Standard Time</option>
                                    <option value="AST" selected={(facilityAdd?.facility_time_zone == "AST") ? "selected" : ""}>AST- Alaska Standard Time</option>
                                    <option value="HST" selected={(facilityAdd?.facility_time_zone == "HST") ? "selected" : ""}>HST - Hawaii Standard Time</option>
                                </select>
                                {inputError &&
                                    !facilityAdd?.facility_time_zone && (
                                        <span className="text-danger">Select time zone</span>
                                    )}


                            </div>




                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <label htmlFor="facility_address">ADDRESS*</label>
                                <input name="facility_address" id="facility_address" type="text" className="form-control"
                                    value={facilityAdd?.facility_address}
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_address: e.target.value })
                                    }

                                />
                                {inputError && !facilityAdd?.facility_address &&
                                    <span className="text-danger">Enter address</span>
                                }



                            </div>


                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <label htmlFor="facility_city">CITY*</label>

                                <input name="facility_city" id="facility_city" type="text" className="form-control"
                                    value={facilityAdd?.facility_city}
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_city: e.target.value })
                                    }

                                />

                                {inputError && !facilityAdd?.facility_city &&
                                    <span className="text-danger">Enter city</span>
                                }


                            </div>


                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <div className="row" >
                                    <div className="col-6">

                                        <label htmlFor="facility_state">STATE*</label>

                                        <input name="facility_state" id="facility_state" type="text"
                                            className="form-control"
                                            value={facilityAdd?.facility_state} onChange={(e) =>
                                                setFacilityAdd({ ...facilityAdd, facility_state: e.target.value })
                                            }
                                        />

                                        {inputError && !facilityAdd?.facility_state &&
                                            <span className="text-danger">Enter state</span>
                                        }



                                    </div>
                                    <div className="col-6">
                                        <label htmlFor="facility_zip">ZIP*</label>

                                        <input name="facility_zip" id="facility_zip" type="text"
                                            className="form-control"
                                            value={facilityAdd?.facility_zip} onChange={(e) =>
                                                setFacilityAdd({ ...facilityAdd, facility_zip: e.target.value })
                                            }
                                        />

                                        {inputError && !facilityAdd?.facility_zip &&
                                            <span className="text-danger">Enter zip</span>
                                        }


                                    </div>
                                </div>
                            </div>



                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">


                                <label htmlFor="facility_phone" >TELEPHONE*</label>

                                <input name="facility_phone" id="facility_phone" type="text" className="form-control"
                                    value={facilityAdd?.facility_phone} onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_phone: e.target.value })
                                    }
                                />

                                {inputError && !facilityAdd?.facility_phone &&
                                    <span className="text-danger">Enter Phone</span>
                                }

                            </div>

                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <label htmlFor="facility_fax">FAX</label>

                                <input name="facility_fax" id="facility_fax" type="text" className="form-control"
                                    value={facilityAdd?.facility_fax} onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_fax: e.target.value })
                                    }

                                />

                            </div>



                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <label htmlFor="facility_contact_name">CONTACT NAME</label>
                                <input name="facility_contact_name" id="facility_contact_name" type="text"
                                    className="form-control"
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_contact_name: e.target.value })
                                    }

                                />

                                {inputError && !facilityAdd?.facility_contact_name &&
                                    <span className="text-danger">Enter contact name</span>
                                }



                            </div>
                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <label htmlFor="facility_contact_email">CONTACT EMAIL</label>

                                <input name="facility_contact_email" id="facility_contact_email" type="text" className="form-control"
                                    value={facilityAdd?.facility_contact_email}
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_contact_email: e.target.value })
                                    }

                                />
                                {inputError &&
                                    (facilityAdd?.facility_contact_email && !facilityAdd?.facility_contact_email?.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) && (
                                        <span className="text-danger">Enter a valid email</span>
                                    )}

                            </div>

                            <div className="col-xl-3 col-lg-3 col-sm-6 my-2">
                                <div className="row">
                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_contact_phone">CONTACT PHONE</label>

                                        <input name="facility_contact_phone" id="facility_contact_phone" type="text" className="form-control"
                                            value={facilityAdd?.facility_contact_phone}
                                            onChange={(e) =>
                                                setFacilityAdd({ ...facilityAdd, facility_contact_phone: e.target.value })
                                            }

                                        />


                                    </div>
                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_contact_fax">CONTACT FAX</label>

                                        <input name="facility_contact_fax" id="facility_contact_fax" type="text" className="form-control"
                                            value={facilityAdd?.facility_contact_fax}
                                            onChange={(e) =>
                                                setFacilityAdd({ ...facilityAdd, facility_contact_fax: e.target.value })
                                            }

                                        />


                                    </div>

                                </div>
                            </div>

                            <div className="col-6 my-2">
                                <label htmlFor="facility_notes">NOTES</label>
                                <textarea rows="4" name="facility_notes" id="facility_notes"
                                    className="form-control"
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_notes: e.target.value })
                                    }

                                >
                                    {facilityAdd?.facility_notes}
                                </textarea>


                            </div>
                            <div className="col-6 my-2">
                                <label htmlFor="facility_internal_notes">INTERNAL NOTES</label>

                                <textarea rows="4" name="facility_internal_notes" id="facility_internal_notes"
                                    className="form-control"
                                    onChange={(e) =>
                                        setFacilityAdd({ ...facilityAdd, facility_internal_notes: e.target.value })
                                    }
                                    value={facilityAdd?.facility_internal_notes}

                                >
                                    {facilityAdd?.facility_internal_notes}
                                </textarea>

                            </div>


                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                                <button onClick={() => saveFacility()} className="btn btn-success me-1 mt-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                                <button onClick={() => { resetAddFacility(); }} className="btn btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>

                            </div>
                        </div>
                    </div>

                </div>
            }


            {searchMode &&
                <>
                    <div className="card card-form card-primary mb-3">
                        <div className="card-heading px-5 py-2"><h6 className="fw-bold my-0">SEARCH PATIENTS</h6></div>
                        <div className="card-body">
                            <form className="form-horizontal form-thick mb-2"  >



                                <div className="row">

                                    <div className="col-md-3 col-sm-3 mb-2">
                                        <label htmlFor="facility_name" >Facility</label>
                                        <input name="facility_name" className="form-control" type="text"
                                            value={facilitySearch?.facility_name}
                                            onChange={(e) =>
                                                setFacilitySearch({ ...facilitySearch, facility_name: e.target.value })
                                            }

                                        />


                                    </div>



                                    <div className="col-md-3 col-sm-3 mb-2">
                                        <label htmlFor="facility_address">Address</label>
                                        <input name="facility_address" id="facility_address" type="text" className="form-control"
                                            value={facilitySearch?.facility_address}
                                            onChange={(e) =>
                                                setFacilitySearch({ ...facilitySearch, facility_address: e.target.value })
                                            }

                                        />
                                    </div>
                                    <div className="col-md-3 col-sm-3 mb-2">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <label htmlFor="facility_city">City</label>
                                                <input name="facility_city" id="facility_city" type="text" className="form-control"
                                                    value={facilitySearch?.facility_city}
                                                    onChange={(e) =>
                                                        setFacilitySearch({ ...facilitySearch, facility_city: e.target.value })
                                                    }

                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <label htmlFor="facility_state">State</label>
                                                <input name="facility_state" id="facility_state" type="text" className="form-control"
                                                    value={facilitySearch?.facility_state}
                                                    onChange={(e) =>
                                                        setFacilitySearch({ ...facilitySearch, facility_state: e.target.value })
                                                    }

                                                />
                                            </div>
                                        </div>

                                    </div>



                                    <div className="col-md-3 col-sm-3 mb-2">
                                        <label htmlFor="facility_contact_name">Contact Name</label>
                                        <input name="facility_contact_name" id="facility_contact_name" type="text" className="form-control"
                                            value={facilitySearch?.facility_contact_name} onChange={(e) =>
                                                setFacilitySearch({ ...facilitySearch, facility_contact_name: e.target.value })
                                            }
                                        />

                                    </div>



                                </div>


                            </form>
                        </div>
                        <div className="card-footer">


                            <div className="container text-center">

                                <button type='button' onClick={() => searchFacilities()} className="btn btn-success me-1" disabled={isBtn}>
                                    {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status">

                                    </div><span className="sr-only">Loading...</span></> : 'Search'}
                                </button>
                                <button type='button' className="btn btn-warning" onClick={(e) => resetSearchFacilities()}  >Cancel</button>
                            </div>

                        </div>
                    </div>



                </>
            }

            {isLoading ?

                <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />

                :
                <>


                    {facilities &&
                        <>
                            <div className="card card-form card-primary  h-100 " >
                                <div className="card-body p-0 mb-5" >


                                    <PrimaryTable columns={columns} data={facilities} />
                                </div>
                            </div>
                        </>
                    }
                </>
            }









            <Modal animation={false}
                show={editFacilityModalOpen}
                onHide={() => { setEditFacilityModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="search-facility-modal"
                size="lg"
            >
                <Modal.Header><h3 className="m-0 p-0">UPDATE FACILITY</h3></Modal.Header>
                <Modal.Body>
                    <div className="modal-inner-content form-thick">


                        {isLoading ?
                            <div className="text-center m-auto loader" >
                                <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
                            </div>
                            :


                            <>
                                <div className="row px-3 py-2 gx-2 ">

                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_name" >Facility*</label>

                                        <input name="facility_name" className="form-control" type="text"
                                            value={facilityEdit?.facility_name}
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_name: e.target.value })
                                            }

                                        />
                                        {inputError && !facilityEdit?.facility_name &&
                                            <span className="text-danger">Enter valid name</span>
                                        }




                                    </div>
                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_attn">ATTN</label>

                                        <input name="facility_attn" className="form-control"
                                            value={facilityEdit?.facility_attn}
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_attn: e.target.value })
                                            }

                                        />

                                    </div>


                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_time_zone">Time Zone</label>

                                        <select name="facility_time_zone" className=" form-select"
                                            value={facilityEdit?.facility_time_zone}
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_time_zone: e.target.value })
                                            }
                                        >
                                            <option value="" selected={(!facilityEdit?.facility_time_zone || facilityEdit?.facility_time_zone == "") ? "selected" : ""} ></option>
                                            <option value="OUS" selected={(facilityEdit?.facility_time_zone == "OUS") ? "selected" : ""} >OUS - Outside The United States</option>
                                            <option value="EST" selected={(facilityEdit?.facility_time_zone == "EST") ? "selected" : ""}>EST: Eastern Standard Time</option>
                                            <option value="CST" selected={(facilityEdit?.facility_time_zone == "CST") ? "selected" : ""}>CST: Central Standard Time</option>
                                            <option value="MST" selected={(facilityEdit?.facility_time_zone == "MST") ? "selected" : ""}>MST - Mountain Standard Time</option>
                                            <option value="PST" selected={(facilityEdit?.facility_time_zone == "PST") ? "selected" : ""}>PST - Pacific Standard Time</option>
                                            <option value="AST" selected={(facilityEdit?.facility_time_zone == "AST") ? "selected" : ""}>AST- Alaska Standard Time</option>
                                            <option value="HST" selected={(facilityEdit?.facility_time_zone == "HST") ? "selected" : ""}>HST - Hawaii Standard Time</option>
                                        </select>


                                    </div>




                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_address">ADDRESS*</label>
                                        <input name="facility_address" id="facility_address" type="text" className="form-control"
                                            value={facilityEdit?.facility_address}
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_address: e.target.value })
                                            }

                                        />
                                        {inputError && !facilityEdit?.facility_address &&
                                            <span className="text-danger">Enter address</span>
                                        }



                                    </div>


                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_city">CITY*</label>

                                        <input name="facility_city" id="facility_city" type="text" className="form-control"
                                            value={facilityEdit?.facility_city}
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_city: e.target.value })
                                            }

                                        />

                                        {inputError && !facilityEdit?.facility_city &&
                                            <span className="text-danger">Enter city</span>
                                        }


                                    </div>


                                    <div className="col-6 my-2">
                                        <div className="row" >
                                            <div className="col-6">

                                                <label htmlFor="facility_state">STATE*</label>

                                                <input name="facility_state" id="facility_state" type="text"
                                                    className="form-control"
                                                    value={facilityEdit?.facility_state} onChange={(e) =>
                                                        setFacilityEdit({ ...facilityEdit, facility_state: e.target.value })
                                                    }
                                                />

                                                {inputError && !facilityEdit?.facility_state &&
                                                    <span className="text-danger">Enter state</span>
                                                }



                                            </div>
                                            <div className="col-6">
                                                <label htmlFor="facility_zip">ZIP*</label>

                                                <input name="facility_zip" id="facility_zip" type="text"
                                                    className="form-control"
                                                    value={facilityEdit?.facility_zip} onChange={(e) =>
                                                        setFacilityEdit({ ...facilityEdit, facility_zip: e.target.value })
                                                    }
                                                />

                                                {inputError && !facilityEdit?.facility_zip &&
                                                    <span className="text-danger">Enter zip</span>
                                                }


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-6 my-2">


                                        <label htmlFor="facility_phone" >TELEPHONE</label>

                                        <input name="facility_phone" id="facility_phone" type="text" className="form-control"
                                            value={facilityEdit?.facility_phone} onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_phone: e.target.value })
                                            }
                                        />


                                    </div>

                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_fax">FAX</label>

                                        <input name="facility_fax" id="facility_fax" type="text" className="form-control"
                                            value={facilityEdit?.facility_fax} onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_fax: e.target.value })
                                            }

                                        />

                                    </div>



                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_contact_name">CONTACT NAME</label>
                                        <input name="facility_contact_name" id="facility_contact_name" type="text"
                                            className="form-control"
                                            value={facilityEdit?.facility_contact_name}
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_contact_name: e.target.value })
                                            }

                                        />


                                    </div>
                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_contact_email">CONTACT EMAIL</label>

                                        <input name="facility_contact_email" id="facility_contact_email" type="text" className="form-control"
                                            value={facilityEdit?.facility_contact_email}
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_contact_email: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!facilityEdit?.facility_contact_email?.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) && (
                                                <span className="text-danger">Enter a valid email</span>
                                            )}

                                    </div>

                                    <div className="col-6 my-2">
                                        <div className="row">
                                            <div className="col-6 my-2">
                                                <label htmlFor="facility_contact_phone">CONTACT PHONE</label>

                                                <input name="facility_contact_phone" id="facility_contact_phone" type="text" className="form-control"
                                                    value={facilityEdit?.facility_contact_phone}
                                                    onChange={(e) =>
                                                        setFacilityEdit({ ...facilityEdit, facility_contact_phone: e.target.value })
                                                    }

                                                />


                                            </div>
                                            <div className="col-6 my-2">
                                                <label htmlFor="facility_contact_fax">CONTACT FAX</label>

                                                <input name="facility_contact_fax" id="facility_contact_fax" type="text" className="form-control"
                                                    value={facilityEdit?.facility_contact_fax}
                                                    onChange={(e) =>
                                                        setFacilityEdit({ ...facilityEdit, facility_contact_fax: e.target.value })
                                                    }

                                                />


                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_notes">NOTES</label>
                                        <textarea rows="4" name="facility_notes" id="facility_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_notes: e.target.value })
                                            }

                                        >
                                            {facilityEdit?.facility_notes}
                                        </textarea>


                                    </div>
                                    <div className="col-6 my-2">
                                        <label htmlFor="facility_internal_notes">INTERNAL NOTES</label>

                                        <textarea rows="4" name="facility_internal_notes" id="facility_internal_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setFacilityEdit({ ...facilityEdit, facility_internal_notes: e.target.value })
                                            }
                                            value={facilityEdit?.facility_internal_notes}

                                        >
                                            {facilityEdit?.facility_internal_notes}
                                        </textarea>

                                    </div>


                                </div>

                            </>
                        }

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="container-fluid text-center">
                        <button type='button' onClick={() => updateFacility()} className="btn  btn-success me-1" disabled={isBtn}>
                            {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status">

                            </div><span className="sr-only">Loading...</span></> : 'UPDATE FACILITY'}
                        </button>
                        <button type='button' className="btn  btn-warning" onClick={(e) => setEditFacilityModalOpen(false)}  >CANCEL UPDATE</button>
                    </div>

                </Modal.Footer>
            </Modal>







            <Modal animation={false}
                show={isMergeModalOpen}
                onHide={() => { setIsMergeModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="search-merge-modal"
                size="lg"
            >
                <Modal.Header>
                    <h3 className="m-0 p-0">FACILITIES TO BE MERGED</h3>
                    <button onClick={() => { setIsMergeModalOpen(false); }} type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </Modal.Header>
                <Modal.Body>
                    <div className="modal-inner-content ">


                        <div className="row pb-4">

                            <div className="col-md-12 col-sm-12">

                                {!facilitiesChecked || facilitiesChecked?.length < 2 ?
                                    <label>Please select at least two facilities to be merged</label>
                                    :
                                    <>
                                        <div className="my-4">Please select the primary facility to be merged. <span className="text-danger fw-bold">This action is permanent and cannot be undone.</span></div>
                                        <ul className="list-group">

                                            {facilitiesChecked?.map((f, index) => (

                                                <li key={index} className={f.facility_id == facilityChecked?.facility_id ? "active list-group-item" : "list-group-item"}
                                                    onClick={e => {

                                                        setFacilityChecked(f);
                                                    }}
                                                >


                                                    <input key={f.facility_id} name="facility_id[]" className="form-check-input mx-3" type="checkbox"
                                                        checked={(f.facility_id == facilityChecked?.facility_id) ? true : false} value={f.facility_id}
                                                        onClick={e => {

                                                            setFacilityChecked(f);

                                                        }}
                                                    />
                                                    {f.facility_name + " " + f.facility_attn + " " + f.facility_address + ", " + f.facility_city + ", " + f.facility_state}
                                                </li>

                                            ))}
                                        </ul>
                                    </>


                                }


                            </div>


                        </div>



                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <div className="container text-center">

                        <button onClick={() => { saveMergeFacilities(); }} className="btn btn-warning me-1">Merge</button>
                        <button className="btn btn-danger" onClick={() => { setIsMergeModalOpen(false); }} >Cancel</button>

                    </div>

                </Modal.Footer>
            </Modal>






        </>

    );
};

export default Facilities;